module.exports = __webpack_public_path__ + "static/media/profile.3d5c57ac.png";